import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '../../environments/environment';
import { NotificationResponse, NotificationRequest } from '../models/notifications.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  private baseUrl = environment.apiUrl + 'Notifications';

  constructor(
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private http: HttpClient
  ) {}

  
  private getHeaders(): HttpHeaders {
    const token = this.oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token found');
    return new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${token}`,
    });
  }

  getNotifications(
    clientID: number,
    skip = 0,
    count = 10,
    search?: string,
    sortBy?: string,
    sortDir?: 'asc' | 'desc'
  ): Observable<{ notifications: NotificationResponse[]; totalCount: number }> {

    let params = new HttpParams()
      .set('clientID', clientID.toString())
      .set('skip', skip.toString())
      .set('count', count.toString())
      .set('sortBy', sortBy ?? '')
      .set('sortDir', sortDir ?? '');

    if (search && search.trim()) {
      params = params.set('search', search.trim());
    }

    return this.http.get<{ notifications: NotificationResponse[]; totalCount: number }>(
      this.baseUrl,
      { headers: this.getHeaders(), params }
    );
  }

  addNotification(request: NotificationRequest): Observable<any> {
    return this.http.post<any>(this.baseUrl, request, { headers: this.getHeaders() });
  }

  updateNotification(request: NotificationRequest): Observable<any> {
    return this.http.put<any>(this.baseUrl, request, { headers: this.getHeaders() });
  }
}